const defaultState = {
  authenticated: false,
  username: null,
  password: null
}

export const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'AUTHENTICATE':
      return {
        authenticated: true,
        ...action.payload
      }
    default:
      return state
  }
}
